import { Tabs, Accordion, Mobile, TRANSITION_END } from './core'
import Header from './modules/header'
import Players from './modules/soundcloud'
import Fancybox from '@fancyapps/fancybox'
import './plugins/tabs'
import './plugins/ornament'
import './plugins/load-more-posts'
import './plugins/post-share'
import './plugins/contact-form'
import './plugins/parallax'

$(function() {
  $.mlmi = {
    mobile: new Mobile(),
  }

  /* Header */
  Header.init()

  /* Balado */
  Players.init()

  /* Tabs */
  Tabs.init()

  /* Accordions */
  Accordion.init()

  /* Forms */
  $('.contact-form').each(function() {
    $(this).ContactForm()
  })

  /* Animations */
  $('.heading-underline, .heading-podcast, .heading-magazine').each(function( index ) {
    $(this).wrapInner("<span></span>")
  })

  $('.ornament-row').each(function( index ) {
    $(this).ornamentSection()
  })

  /* Load more posts */
  $('.js-load-more-posts').each(function() {
    $(this).loadMorePosts()
  })

  /* Categories menu */
  $('.js-categories-menu').click(function() {
    $(this).toggleClass('js-categories-menu--open')
    $(this).next('.post-categories').slideToggle()
  })

  /* Fix content */
  $('.post-share').each(function() {
    let fixedContent = $(this).FixedContent({
      topBlocker: $('.header'),
      bottomBlocker: $('.footer'),
      container: $('.single-post__content-wrapper'),
      limitFromTop: 50,
      mobile: true,
    })
  })

  /* Copy page URL */
  $('.post-share__action--copy-link').on('click', function() {
    let self = $(this)
    self.find('textarea').val(window.location.href).focus().select()
    document.execCommand("Copy")
    self.find('span').addClass('visible').text('Lien copié !')
    setTimeout(function() {
      self.find('span').removeClass('visible')
    }, 3200)
  })

  /* Tabs Menu */
  $('.tabs__list').each(function() {
    $(this).slideSelectorMenu()
  })

  /* Sharing */
  $('.post-share').each(function() {
    $(this).PostShare()
  })

  /* Fancybox */
  $('[data-fancybox]').fancybox({
    loop: true,
    buttons: ['close'],
    transitionEffect: 'slide',
    i18n: {
      fr: {
        CLOSE: "Fermer",
        NEXT: "Photo suivante",
        PREV: "Photo précédente",
      },
    },
    lang: 'fr',
    beforeClose: function() {
      let indexes = window.location.hash.split('-')
      if (indexes[0] === '#gallery') {
        let selector = 'gallery-' + indexes[1] + '-' + indexes[2],
        slide = $('[data-fancybox="' + selector + '"]:eq(' + (indexes[3] - 1) + ')'),
        carousel = slide.parents('.carousel').data('carousel')
        carousel.swiper.slideTo(indexes[3] - 1, 0)
      }
    }
  })

  /* Home parallax */
  $('.front-page .page-header__content').each(function() {
    $(this).Parallax()
  })
})
